import { Spinner } from 'components/Spinner';
import copy from 'copy/login';
import { AccountSwitchConfirm } from './AccountSwitchConfirm';
import { MagicLinkConfirm } from './MagicLinkConfirm';
import { BizlyLogoPageWithCard } from './ui';
import { useAuthenticate } from './util';

export default function ActivateNewUser() {
    const { hasToken, authenticating, authenticate, pendingSwitch, confirmSwitch, cancelSwitch } =
        useAuthenticate(true);

    return (
        <BizlyLogoPageWithCard heading={copy.acceptInvite.heading}>
            {pendingSwitch ? (
                <AccountSwitchConfirm
                    fromEmail={pendingSwitch.fromEmail}
                    toEmail={pendingSwitch.toEmail}
                    authenticating={authenticating}
                    onConfirm={confirmSwitch}
                    onCancel={cancelSwitch}
                />
            ) : hasToken ? (
                <MagicLinkConfirm
                    authenticating={authenticating}
                    onConfirm={authenticate}
                    title="Accept your invitation"
                    description="Click below to join your team on Bizly."
                    buttonLabel="Accept invitation"
                />
            ) : (
                <Spinner />
            )}
        </BizlyLogoPageWithCard>
    );
}
